/**
 * Traducciones para categorías/temáticas sensibles
 * Soporta: ES, EN, DE, FR, IT
 */

export const sensitiveTopicsTranslations = {
  // Casino / Casinos
  casino: {
    es: 'Casino',
    en: 'Casino',
    de: 'Casino',
    fr: 'Casino',
    it: 'Casinò'
  },
  casinos: {
    es: 'Casinos',
    en: 'Casinos',
    de: 'Casinos',
    fr: 'Casinos',
    it: 'Casinò'
  },
  
  // Gambling / Apuestas
  gambling: {
    es: 'Apuestas',
    en: 'Gambling',
    de: 'Glücksspiel',
    fr: 'Jeux d\'argent',
    it: 'Gioco d\'azzardo'
  },
  apuestas: {
    es: 'Apuestas',
    en: 'Gambling',
    de: 'Glücksspiel',
    fr: 'Jeux d\'argent',
    it: 'Gioco d\'azzardo'
  },
  
  // CBD / Cannabis
  cbd: {
    es: 'CBD',
    en: 'CBD',
    de: 'CBD',
    fr: 'CBD',
    it: 'CBD'
  },
  cannabis: {
    es: 'Cannabis',
    en: 'Cannabis',
    de: 'Cannabis',
    fr: 'Cannabis',
    it: 'Cannabis'
  },
  
  // Cryptocurrency / Criptomonedas
  cryptocurrency: {
    es: 'Criptomonedas',
    en: 'Cryptocurrency',
    de: 'Kryptowährung',
    fr: 'Cryptomonnaie',
    it: 'Criptovaluta'
  },
  criptomonedas: {
    es: 'Criptomonedas',
    en: 'Cryptocurrency',
    de: 'Kryptowährung',
    fr: 'Cryptomonnaie',
    it: 'Criptovaluta'
  },
  crypto: {
    es: 'Criptomonedas',
    en: 'Cryptocurrency',
    de: 'Kryptowährung',
    fr: 'Cryptomonnaie',
    it: 'Criptovaluta'
  },
  
  // Erotic / Erótico
  erotic: {
    es: 'Erótico',
    en: 'Erotic',
    de: 'Erotik',
    fr: 'Érotique',
    it: 'Erotico'
  },
  erotico: {
    es: 'Erótico',
    en: 'Erotic',
    de: 'Erotik',
    fr: 'Érotique',
    it: 'Erotico'
  },
  
  // Sex / Sexo
  sex: {
    es: 'Sexo',
    en: 'Sex',
    de: 'Sex',
    fr: 'Sexe',
    it: 'Sesso'
  },
  sexo: {
    es: 'Sexo',
    en: 'Sex',
    de: 'Sex',
    fr: 'Sexe',
    it: 'Sesso'
  },
  sexuality: {
    es: 'Sexualidad',
    en: 'Sexuality',
    de: 'Sexualität',
    fr: 'Sexualité',
    it: 'Sessualità'
  },
  
  // Porn / Porno
  porn: {
    es: 'Porno',
    en: 'Porn',
    de: 'Porno',
    fr: 'Porno',
    it: 'Porno'
  },
  porno: {
    es: 'Porno',
    en: 'Porn',
    de: 'Porno',
    fr: 'Porno',
    it: 'Porno'
  },
  
  // VPN
  vpn: {
    es: 'VPN',
    en: 'VPN',
    de: 'VPN',
    fr: 'VPN',
    it: 'VPN'
  },
  
  // Tarot / Esoterismo
  tarot: {
    es: 'Tarot',
    en: 'Tarot',
    de: 'Tarot',
    fr: 'Tarot',
    it: 'Tarocchi'
  },
  esotericism: {
    es: 'Esoterismo',
    en: 'Esotericism',
    de: 'Esoterik',
    fr: 'Ésotérisme',
    it: 'Esoterismo'
  },
  seer: {
    es: 'Videncia',
    en: 'Fortune Telling',
    de: 'Wahrsagerei',
    fr: 'Voyance',
    it: 'Veggenza'
  },
  
  // Adults / Adultos
  adultos: {
    es: 'Adultos',
    en: 'Adults',
    de: 'Erwachsene',
    fr: 'Adultes',
    it: 'Adulti'
  },
  adults: {
    es: 'Adultos',
    en: 'Adults',
    de: 'Erwachsene',
    fr: 'Adultes',
    it: 'Adulti'
  },
  
  // Escorts
  escorts: {
    es: 'Escorts',
    en: 'Escorts',
    de: 'Escorts',
    fr: 'Escorts',
    it: 'Escort'
  },
  
  // Dating / Citas
  dating: {
    es: 'Citas',
    en: 'Dating',
    de: 'Dating',
    fr: 'Rencontres',
    it: 'Incontri'
  },
  
  // Drugs / Drogas
  drugs: {
    es: 'Drogas',
    en: 'Drugs',
    de: 'Drogen',
    fr: 'Drogues',
    it: 'Droghe'
  },
  
  // Forex / Trading
  forex: {
    es: 'Forex',
    en: 'Forex',
    de: 'Forex',
    fr: 'Forex',
    it: 'Forex'
  },
  trading: {
    es: 'Trading',
    en: 'Trading',
    de: 'Trading',
    fr: 'Trading',
    it: 'Trading'
  },
  
  // Loans / Préstamos
  prestamos: {
    es: 'Préstamos',
    en: 'Loans',
    de: 'Kredite',
    fr: 'Prêts',
    it: 'Prestiti'
  },
  loans: {
    es: 'Préstamos',
    en: 'Loans',
    de: 'Kredite',
    fr: 'Prêts',
    it: 'Prestiti'
  },
  
  // Vaper / Vaping
  vaper: {
    es: 'Vapeo',
    en: 'Vaping',
    de: 'Dampfen',
    fr: 'Vapotage',
    it: 'Svapo'
  },
  vaping: {
    es: 'Vapeo',
    en: 'Vaping',
    de: 'Dampfen',
    fr: 'Vapotage',
    it: 'Svapo'
  }
};

/**
 * Obtiene la traducción de una categoría sensible
 * @param {string} key - Clave de la categoría (ej: 'casino', 'gambling')
 * @param {string} language - Código del idioma (es, en, de, fr, it)
 * @returns {string} - Traducción o el key original si no existe
 */
export const getSensitiveTopicLabel = (key, language = 'es') => {
  const normalizedKey = key?.toLowerCase()?.replace(/\s+/g, '_')?.replace(/[áàä]/g, 'a')?.replace(/[éèë]/g, 'e')?.replace(/[íìï]/g, 'i')?.replace(/[óòö]/g, 'o')?.replace(/[úùü]/g, 'u');
  
  const translation = sensitiveTopicsTranslations[normalizedKey];
  
  if (translation && translation[language]) {
    return translation[language];
  }
  
  // Fallback to Spanish, then English, then original key
  if (translation) {
    return translation['es'] || translation['en'] || key;
  }
  
  // Capitalize first letter if no translation found
  return key?.charAt(0)?.toUpperCase() + key?.slice(1)?.toLowerCase() || key;
};

/**
 * Traducciones para etiquetas de UI relacionadas con temáticas sensibles
 */
export const sensitiveUITranslations = {
  sensitiveTopics: {
    es: 'Temáticas Sensibles',
    en: 'Sensitive Topics',
    de: 'Sensible Themen',
    fr: 'Sujets Sensibles',
    it: 'Argomenti Sensibili'
  },
  accepts: {
    es: 'Acepta',
    en: 'Accepts',
    de: 'Akzeptiert',
    fr: 'Accepte',
    it: 'Accetta'
  },
  notAccepts: {
    es: 'No acepta temáticas sensibles',
    en: 'Does not accept sensitive topics',
    de: 'Akzeptiert keine sensiblen Themen',
    fr: 'N\'accepte pas les sujets sensibles',
    it: 'Non accetta argomenti sensibili'
  },
  noSensitiveTopics: {
    es: 'Sin temáticas sensibles',
    en: 'No sensitive topics',
    de: 'Keine sensiblen Themen',
    fr: 'Pas de sujets sensibles',
    it: 'Nessun argomento sensibile'
  },
  filterBySensitive: {
    es: 'Filtrar por temáticas',
    en: 'Filter by topics',
    de: 'Nach Themen filtern',
    fr: 'Filtrer par sujets',
    it: 'Filtra per argomenti'
  }
};

export const getSensitiveUILabel = (key, language = 'es') => {
  const translation = sensitiveUITranslations[key];
  if (translation && translation[language]) {
    return translation[language];
  }
  return translation?.['es'] || key;
};
